import { channels } from '@/mocks/channels';

export default function ChannelSection() {
  return (
    <section id="channels" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
            <i className="ri-apps-2-line" />
            栏目频道
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">六大频道，分门别类快速追更</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            每条速报都归入对应频道，想只看一类就切一类，想一口气看全部就点"实时速报"。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((c) => (
            <article
              key={c.id}
              className="group overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition hover:-translate-y-1 hover:border-primary-200"
            >
              <a href="#feed" className="block">
                <div className="relative aspect-[8/5] overflow-hidden">
                  <img
                    src={c.image}
                    alt={`${c.name}频道相关插画`}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-bold text-foreground-800">
                    {c.count}
                  </span>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2">
                    <span className={`grid h-8 w-8 place-items-center rounded-lg text-background-50 ${c.color}`}>
                      <i className={c.icon} style={{ fontSize: 16 }} />
                    </span>
                    <div>
                      <h3 className="font-heading text-xl leading-none text-foreground-950">{c.name}</h3>
                      <p className="text-[11px] uppercase tracking-wider text-foreground-400">{c.en}</p>
                    </div>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                    进入频道追更
                    <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
                  </span>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}